import { useSelector, useDispatch } from 'react-redux';
import Search from '../components/Search';
import { useLegacyApi } from '../../../routes/legacyApiHook';
import {
  setPage,
  fetchCityOptions,
  fetchRegionOptions,
  fetchCountryOptions,
  resetFilterSet,
} from '../../../features/request/actions';
import type { RootState } from '../../../config/redux/types';
import { SEARCH } from '../../../routes/config/pageTypes';

export default function SearchContainer(): JSX.Element {
  const searchResults = useSelector((state: RootState) => state.searchResults);
  const locale = useSelector((state: RootState) => state.routes.locale);
  const request = useSelector((state: RootState) => state.request);
  const dispatch = useDispatch();

  useLegacyApi(undefined, SEARCH);

  return (
    <Search
      hosts={searchResults.results}
      totalPages={searchResults.totalPages}
      loading={searchResults.loading}
      lang={locale}
      request={request}
      fetchCountryOptions={(): void => {
        dispatch(fetchCountryOptions());
      }}
      fetchRegionOptions={(countryCode: string): void => {
        dispatch(fetchRegionOptions(countryCode));
      }}
      fetchCityOptions={(countryCode: string, region: string): void => {
        dispatch(fetchCityOptions(countryCode, region));
      }}
      onPageChange={(pageIndex: number): void => {
        dispatch(setPage(pageIndex + 1));
      }}
      resetFilterSet={(): void => {
        dispatch(resetFilterSet());
      }}
    />
  );
}
